import { useState } from "react";
import {
  DEFAULT_FLASH_SCREEN_COUPON,
  DEFAULT_FLASH_SCREEN_HEADING,
} from "../../../config/Constant";
import {
  DEFAULT_MOBILE_LENGTH,
  DEFAULT_MOBILE_PREFIX,
} from "../../../Redux/Constants/GlobalConstant";
import { toast } from "react-toastify";
import Toast from "../../../components/LoadingError/Toast";
import { useDispatch } from "react-redux";
import { registerFlashUser } from "../../../features/user/userThunks";

const LoginCoupon = ({ show }) => {
  const dispatch = useDispatch();

  const flashUser = localStorage.getItem("flashUser");

  const ToastObjects = {
    pauseOnFocusLoss: false,
    draggable: false,
    pauseOnHover: false,
    autoClose: 2000,
  };

  const [showModel, setShowModel] = useState(show);
  const [mobile, setMobile] = useState("");
  const [showCoupon, setShowCoupon] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [copied, setCopied] = useState(false);

  const couponCode = DEFAULT_FLASH_SCREEN_COUPON;

  const showHideClassName =
    showModel && !flashUser ? "modal display-block" : "modal display-none";

  const tempFlashUser = {
    label: "flashUser",
    name: null,
    isMobile: isMobile,
    mobile: mobile,
    dTime: null,
    postCode: null,
    deliveryEnabled: null,
  };

  // ✅ CLOSE MODAL HANDLER
  const handleModalClose = () => {
    setShowModel(false);

    // optional: mark as skipped so it doesn't reopen
    localStorage.setItem("flashUser", JSON.stringify({ skipped: true }));
  };

  const handleClose = () => {
    if (new RegExp(`^\\d{${DEFAULT_MOBILE_LENGTH}}$`).test(mobile)) {
      setIsMobile(true);
      setShowCoupon(true);

      const updatedUser = { ...tempFlashUser, isMobile: true };

      handleCopy(updatedUser);

      // API call
      dispatch(registerFlashUser(updatedUser));
    } else {
      let userRes = window.confirm("Do you want to Continue Without Coupon?");
      if (userRes) {
        toast.success("Login to Get Coupon", ToastObjects);
        handleCopy(tempFlashUser);
      } else {
        return;
      }
    }
  };

  const handleChange = (e) => {
    let value = e.target.value;

    if (value.length > 0 && value[0] !== DEFAULT_MOBILE_PREFIX) {
      value = DEFAULT_MOBILE_PREFIX + value;
    }

    if (value.length === DEFAULT_MOBILE_LENGTH) {
      if (!new RegExp(`^\\d{${DEFAULT_MOBILE_LENGTH}}$`).test(value)) {
        alert("Invalid Mobile Number");
      }
    }

    setMobile(value);
  };

  // ✅ COPY FUNCTION
  const handleCopy = (data) => {
    if (data.isMobile) {
      navigator.clipboard.writeText(couponCode);
      setCopied(true);
    }

    setTimeout(() => {
      localStorage.setItem("flashUser", JSON.stringify(data));
      setShowModel(false);
      setCopied(false);
    }, 2000);
  };

  return (
    <div className={showHideClassName}>
      <Toast />

      <section className="modal-main" style={{ position: "relative" }}>
        {/* ✅ CROSS BUTTON */}
        <button
          type="button"
          className="btn-close"
          onClick={handleModalClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            cursor: "pointer",
            zIndex:1
          }}
        ></button>

        <div className="Login text-center">
          <label className="d-block">{DEFAULT_FLASH_SCREEN_HEADING}</label>

          <img
            src={"/flash/pop-up-presentation.png"}
            alt="Coupon Banner"
            className="img-fluid rounded"
          />

          {/* MOBILE INPUT */}
          <input
            type="numeric"
            pattern="[0-9]*"
            maxLength={DEFAULT_MOBILE_LENGTH}
            placeholder="Mobile (Optional)"
            value={mobile}
            onChange={handleChange}
            inputMode="numeric"
            minLength={DEFAULT_MOBILE_LENGTH}
          />

          {/* BUTTON */}
          {!showCoupon && (
            <div>
              <button
                type="button"
                onClick={handleClose}
                style={{ cursor: "pointer" }}
              >
                Show Coupon
              </button>
            </div>
          )}

          {/* COUPON */}
          {showCoupon && (
            <div className="mt-3">
              <input
                type="text"
                value={couponCode}
                readOnly
                onClick={() => handleCopy(tempFlashUser)}
                className="form-control text-center fw-bold"
                style={{ cursor: "pointer" }}
              />

              {copied && <small className="text-success">Copied!</small>}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default LoginCoupon;
